import { FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material';
import { useColorScheme } from '@mui/material/styles';

import useCloudSourceForm from '../../CloudSourceHooks/useCloudSourceForm.hooks';
import useStyles from '../../SourceCreate.styles';
import { shouldShowCertificateModeSelector } from '../authenticationVisibility.utils';

/**
 * Certificate mode selector component.
 * Allows users to choose between generating a new certificate or uploading an existing one.
 * Shown during creation or regeneration when certificate authentication is selected.
 */
const CertificateModeSelector = () => {
  const { mode: themeMode } = useColorScheme();
  const {
    mode,
    connectionInputSchema,
    authenticationMode,
    newCertificate,
    regenerateCertificate,
    handleCertificationModeChange
  } = useCloudSourceForm();

  const { classes } = useStyles({ themeMode });

  if (
    !shouldShowCertificateModeSelector(
      mode,
      authenticationMode,
      regenerateCertificate,
      connectionInputSchema
    )
  ) {
    return null;
  }

  return (
    <Grid size={{ xs: 12, sm: 6, md: 4 }}>
      <InputLabel htmlFor="device-name-input">Certificate</InputLabel>
      <FormControl fullWidth>
        <div className={classes.dFlex}>
          <Select
            sx={{ width: '100%' }}
            size="small"
            value={newCertificate ? 'new' : 'existing'}
            onChange={(e) => handleCertificationModeChange(e.target.value)}
          >
            <MenuItem value="existing">Existing Certificate Upload</MenuItem>
            <MenuItem value="new">New Certificate Generation</MenuItem>
          </Select>
        </div>
      </FormControl>
    </Grid>
  );
};

export default CertificateModeSelector;
